import { render, staticRenderFns } from "./AppSplittesting.vue?vue&type=template&id=15f76814&scoped=true&"
import script from "./AppSplittesting.vue?vue&type=script&lang=js&"
export * from "./AppSplittesting.vue?vue&type=script&lang=js&"
import style0 from "./AppSplittesting.vue?vue&type=style&index=0&id=15f76814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f76814",
  null
  
)

export default component.exports